<template>
  <modal class="modal" name="login-modal" transition="pop-out" :width="modalWidth" height="auto" :adaptive="true" @before-open="beforeOpen">
    <div class="flex flex-column items-center mb3 background-color">
      <div class="flex justify-end w-100">
        <a @click="closeModal" class="pa3 pointer textColor">
          <font-awesome-icon icon="times"/>
        </a>
      </div>
      <div class="flex justify-center fl w-40 h-100 pb2">
        <img class="h-100 w-100" src="../../../assets/logo-white.svg" alt="BeatHey Logo">
      </div>
      <div class="mv2">
        <clip-loader :loading="loading" :color="color" :size="size"></clip-loader>
      </div>
      <span class="errorText ma3 tc f7" v-if="error">{{error}}</span>
      <login v-if="!forgotModal"></login>
      <forgot-pass v-if="forgotModal"></forgot-pass>
      <p v-show="!forgotModal" class="f6 text-color">{{ $t('users.forgetPassword.question') }} <span @click="forgotTrigger" class="pointer">{{ $t('app.clickHere') }}</span></p>
      <p v-show="forgotModal" class="f6 text-color">{{ $t('users.rememberPassword') }} <span @click="forgotTrigger" class="pointer">{{ $t('app.back') }}</span></p>
    </div>
  </modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import Login from './Login'
  import ForgotPass from './ForgotPass'
  import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
  const MODAL_WIDTH = 500

  export default {
    name: 'login-modal',
    components: {
      FontAwesomeIcon,
      Login,
      ForgotPass,
      ClipLoader
    },
    data () {
      return {
        modalWidth: MODAL_WIDTH,
        forgotModal: false,
        color: '#808080',
        size: '20px'
      }
    },
    created () {
      this.modalWidth = window.innerWidth < MODAL_WIDTH
        ? MODAL_WIDTH / 2
        : MODAL_WIDTH
    },
    computed: {
      ...mapGetters('user', [
        'error'
      ]),
      loading () {
        return this.$loading.isLoading('user login')
      }
    },
    methods: {
      ...mapActions('user', [
        'resetError'
      ]),
      forgotTrigger () {
        this.forgotModal = !this.forgotModal
        this.resetError()
      },
      closeModal () {
        this.$modal.hide('login-modal')
      },
      beforeOpen () {
        this.forgotModal = false
        this.resetError()
      }
    }
  }
</script>
<style scoped lang="scss">
  @import '~@/variables.scss';
  .modal {
    z-index: 10000;
    height: 100%;
    width: 100%;
  }
  .pop-out-enter-active,
  .pop-out-leave-active {
    transition: all 0.5s;
  }
  .pop-out-enter,
  .pop-out-leave-active {
    opacity: 0;
    transform: translateY(24px);
  }
  .background-color{
    background-color: #393839;
  }
  .text-color{
    color: #aaa;
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/login/LoginModal.vue